// @generated
import { PapiCommentThread, PapiComment } from '@wix/da-papi-types';

const legacy: PapiCommentThread[] = [
  {
    total: 1987,
    thread: [
      {
        posted: '2018-08-10T14:46:33-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          '<img src="https://e.deviantart.net/emoticons/w/worry.gif" width="15" height="15" alt=":worry:" data-embed-type="emoticon" data-embed-id="330" title="Worried"/><img src="https://e.deviantart.net/emoticons/x/xd.gif" width="15" height="15" alt=":XD:" data-embed-type="emoticon" data-embed-id="93" title="XD"/><img src="https://e.deviantart.net/emoticons/e/eek.gif" width="15" height="15" alt=":o" data-embed-type="emoticon" data-embed-id="375" title=":o (Eek)"/><img src="https://e.deviantart.net/emoticons/b/bleh.gif" width="15" height="15" alt=":bleh:" data-embed-type="emoticon" data-embed-id="220" title="Bleh"/><img src="https://e.deviantart.net/emoticons/c/cool.gif" width="15" height="15" alt="8-)" data-embed-type="emoticon" data-embed-id="371" title="8-) (Cool)"/><img src="https://e.deviantart.net/emoticons/o/ohnoes.gif" width="15" height="15" alt=":ohnoes:" data-embed-type="emoticon" data-embed-id="555" title="Oh Noes!"/><img src="https://e.deviantart.net/emoticons/c/crying.gif" width="20" height="17" alt=":crying:" data-embed-type="emoticon" data-embed-id="243" title="Crying"/><img src="https://e.deviantart.net/emoticons/f/frown.gif" width="15" height="15" alt=":(" data-embed-type="emoticon" data-embed-id="380" title=":( (Sad)"/><img src="https://e.deviantart.net/emoticons/letters/=p.gif" width="15" height="15" alt=":P" data-embed-type="emoticon" data-embed-id="395" title=":P (Lick)"/><img src="https://e.deviantart.net/emoticons/d/doh.gif" width="15" height="15" alt=":doh:" data-embed-type="emoticon" data-embed-id="166" title="Doh!"/><img src="https://e.deviantart.net/emoticons/s/smile.gif" width="15" height="15" alt=":)" data-embed-type="emoticon" data-embed-id="391" title=":) (Smile)"/><img src="https://e.deviantart.net/emoticons/r/razz.gif" width="15" height="15" alt="=P" data-embed-type="emoticon" data-embed-id="397" title="=P (Razz)"/><img src="https://e.deviantart.net/emoticons/w/wink.gif" width="15" height="15" alt=";)" data-embed-type="emoticon" data-embed-id="387" title=";) (Wink)"/><img src="https://e.deviantart.net/emoticons/m/mad.gif" width="15" height="15" alt=":x" data-embed-type="emoticon" data-embed-id="398" title=":x (Mad)"/><img src="https://e.deviantart.net/emoticons/r/redface.gif" width="15" height="15" alt=":oops:" data-embed-type="emoticon" data-embed-id="374" title="Oops!"/><img src="https://e.deviantart.net/emoticons/r/rage.gif" width="15" height="15" alt=":rage:" data-embed-type="emoticon" data-embed-id="256" title="Rage"/><img src="https://e.deviantart.net/emoticons/s/sarcasm.gif" width="15" height="15" alt=":sarcasm:" data-embed-type="emoticon" data-embed-id="432" title="Hahahahaha. No."/><img src="https://e.deviantart.net/emoticons/e/eager.gif" width="18" height="15" alt=":eager:" data-embed-type="emoticon" data-embed-id="569" title=":eager: by darkmoon3636"/><img src="https://e.deviantart.net/emoticons/t/thanks.gif" width="15" height="15" alt=":thanks:" data-embed-type="emoticon" data-embed-id="488" title="Thanks for everything!"/><img src="https://e.deviantart.net/emoticons/d/dummy.gif" width="21" height="15" alt=":dummy:" data-embed-type="emoticon" data-embed-id="574" title="I am a dummy!"/><img src="https://e.deviantart.net/emoticons/e/eyepopping.gif" width="15" height="15" alt=":eyepopping:" data-embed-type="emoticon" data-embed-id="94" title="Eyepopping"/><img src="https://e.deviantart.net/emoticons/n/nirvana.gif" width="18" height="18" alt=":nirvana:" data-embed-type="emoticon" data-embed-id="47" title="Smells Like Teen Spirit"/>:<img src="https://e.deviantart.net/emoticons/w/w00t.gif" width="23" height="23" alt=":w00t:" data-embed-type="emoticon" data-embed-id="97" title="w00t!"/><img src="https://e.deviantart.net/emoticons/h/happybounce.gif" width="17" height="23" alt=":happybounce:" data-embed-type="emoticon" data-embed-id="599" title=":happybounce:"/><img src="https://e.deviantart.net/emoticons/j/juggling.gif" width="21" height="21" alt=":juggle:" data-embed-type="emoticon" data-embed-id="71" title="Juggle"/><img src="https://e.deviantart.net/emoticons/w/wow.gif" width="23" height="15" alt=":wow:" data-embed-type="emoticon" data-embed-id="480" title="Wow!"/><img src="https://e.deviantart.net/emoticons/o/omg.gif" width="15" height="15" alt=":omg:" data-embed-type="emoticon" data-embed-id="231" title="OMG"/><img src="https://e.deviantart.net/emoticons/d/dance.gif" width="29" height="21" alt=":dance:" data-embed-type="emoticon" data-embed-id="409" title="Dance!"/><img src="https://e.deviantart.net/emoticons/h/headbang.gif" width="47" height="16" alt=":headbang:" data-embed-type="emoticon" data-embed-id="58" title="Headbang!"/><img src="https://e.deviantart.net/emoticons/e/excited.gif" width="23" height="19" alt=":excited:" data-embed-type="emoticon" data-embed-id="509" title="OMG! I can&#039;t contain my excitement!"/><img src="https://e.deviantart.net/emoticons/w/whew.gif" width="25" height="17" alt=":phew:" data-embed-type="emoticon" data-embed-id="486" title="Phew!"/><img src="https://e.deviantart.net/emoticons/c/clap2.gif" width="20" height="20" alt=":clap:" data-embed-type="emoticon" data-embed-id="60" title="Clap"/><img src="https://e.deviantart.net/emoticons/f/faint.gif" width="18" height="17" alt=":faint:" data-embed-type="emoticon" data-embed-id="420" title="I think I&#039;ve fainted."/><img src="https://e.deviantart.net/emoticons/m/meow.gif" width="15" height="15" alt=":meow:" data-embed-type="emoticon" data-embed-id="578" title="Meow :3"/><img src="https://e.deviantart.net/emoticons/g/giggle.gif" width="17" height="15" alt=":giggle:" data-embed-type="emoticon" data-embed-id="100" title="Giggle"/><img src="https://e.deviantart.net/emoticons/s/squee.gif" width="37" height="25" alt=":squee:" data-embed-type="emoticon" data-embed-id="600" title=":squee:"/><img src="https://e.deviantart.net/emoticons/d/disbelief.gif" width="15" height="15" alt=":disbelief:" data-embed-type="emoticon" data-embed-id="338" title="Disbelief"/><img src="https://e.deviantart.net/emoticons/h/horny2.gif" width="15" height="15" alt=":horny:" data-embed-type="emoticon" data-embed-id="342" title="Horny!"/>',
        user: {
          username: 'Moosiful',
          usericon: 'https://a.deviantart.net/avatars/m/o/moosiful.png?8',
          type: 'regular',
          userId: 28951655,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4629886602,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'I can imagine me with Lumpy in that picture.',
            features: '',
          },
        },
        authorInfo: 'Student General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-09T15:21:59-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Fishbreadz',
          usericon: 'https://a.deviantart.net/avatars/default.gif',
          type: 'regular',
          userId: 46389619,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4629482841,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'This is amazing. My old teacher had this masterpiece as his background on the computer lmao',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-09T07:26:44-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Eversoft',
          usericon: 'https://a.deviantart.net/avatars/default.gif',
          type: 'regular',
          userId: 19094665,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4629299109,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Thank you for this piece, it is absolutely stunning. ',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-08T13:28:51-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'imtheavacado',
          usericon: 'https://a.deviantart.net/avatars/i/m/imtheavacado.png?1',
          type: 'regular',
          userId: 45997849,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4629005137,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'its a 3 am meme',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-08T05:14:31-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          '<a href="http://frappe7.deviantart.com/gallery/">My Gallery</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?https://picarto.tv/Frappe7/">Picarto Channel</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?http://frappeart.tumblr.com/">Tumblr</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?https://toyhou.se/frappe7">Toyhouse</a>',
        user: {
          username: 'Frappe7',
          usericon: 'https://a.deviantart.net/avatars/f/r/frappe7.gif?13',
          type: 'beta',
          userId: 29929163,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4628833186,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'this looks romantic ^^',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-07T00:55:45-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'LoganPaulIsSexy',
          usericon: 'https://a.deviantart.net/avatars/l/o/loganpaulissexy.jpg?1',
          type: 'regular',
          userId: 44830392,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4628345929,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Me protecting the frogs from the water.',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-06T17:43:01-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'topaztraitor6',
          usericon: 'https://a.deviantart.net/avatars/t/o/topaztraitor6.jpg?1',
          type: 'regular',
          userId: 46256989,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4628226499,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'deus vult', features: '' },
        },
        authorInfo: 'Hobbyist Artisan Crafter',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-05T08:59:29-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Katelyn78',
          usericon: 'https://a.deviantart.net/avatars/k/a/katelyn78.jpg?3',
          type: 'regular',
          userId: 46357335,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4627574450,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Amazing', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-04T13:30:53-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Cazzzzz',
          usericon: 'https://a.deviantart.net/avatars/c/a/cazzzzz.jpg?1',
          type: 'regular',
          userId: 33055129,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4627259877,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Amazing work! The shadows and the light. And a beautiful composition.',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-03T13:35:35-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'AutobotShadedown',
          usericon: 'https://a.deviantart.net/avatars/a/u/autobotshadedown.jpg?1',
          type: 'regular',
          userId: 44446159,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4626844515,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: ' I remember I loved Medieval stuff when I was little ',
            features: '',
          },
        },
        authorInfo: 'Student Filmographer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-01T16:48:17-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          "spanish/english<br />i'm from argentina, south america. Many times i'm here to see awesome drawings.",
        user: {
          username: 'EPICFABRIZIO',
          usericon: 'https://a.deviantart.net/avatars/e/p/epicfabrizio.png?8',
          type: 'regular',
          userId: 27043067,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4626049846,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'awesome', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-30T23:40:50-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'cucknibba0809',
          usericon: 'https://a.deviantart.net/avatars/default.gif',
          type: 'regular',
          userId: 43939275,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4625292920,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'm e m e', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-30T15:23:30-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Totemos',
          usericon: 'https://a.deviantart.net/avatars/t/o/totemos.gif?6',
          type: 'regular',
          userId: 17788748,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4625131107,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '45,000th favourite and well deserved <img src="https://e.deviantart.net/emoticons/letters/=p.gif" width="15" height="15" alt=":P" data-embed-type="emoticon" data-embed-id="395" title=":P (Lick)"/> Good job',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-29T17:54:24-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Nanomachines4you',
          usericon: 'https://a.deviantart.net/avatars/n/a/nanomachines4you.jpg?1',
          type: 'regular',
          userId: 44817019,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4624744878,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'lol this will forever be the top picture of all pictures',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-29T16:41:32-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Lishadra',
          usericon: 'https://a.deviantart.net/avatars/l/i/lishadra.jpg?6',
          type: 'regular',
          userId: 26063881,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4624719483,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: '<3', features: '' },
        },
        authorInfo: 'Student Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-29T11:06:02-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          'Voted Best Crafter and Most Shameless Self Promoter of the dA Forums! <img src="https://e.deviantart.net/emoticons/w/winner.gif" width="15" height="29" alt=":winner:" data-embed-type="emoticon" data-embed-id="73" title="Winner"/><br />--<br />Avatar by <span class="username-with-symbol u"><a class="u beta username" href="https://zagittorch.deviantart.com">Zagittorch</a><span class="user-symbol beta" data-quicktip-text="Beta Tester" data-show-tooltip="1" data-gruser-type="beta"></span></span>. Have you seen the plushies? <a class="external" href="https://www.deviantart.com/users/outgoing?http://tinyurl.com/plush923">tinyurl.com/plush923</a>',
        user: {
          username: 'MasterPlanner',
          usericon: 'https://a.deviantart.net/avatars/m/a/masterplanner.gif?1',
          type: 'beta',
          userId: 1557968,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4624586348,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'I was wondering where the meme came from',
            features: '',
          },
        },
        authorInfo: 'Professional Artisan Crafter',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-28T05:18:35-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'AestheticPone',
          usericon: 'https://a.deviantart.net/avatars/a/e/aestheticpone.png?1',
          type: 'regular',
          userId: 46293185,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4624053789,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Wow! That is some great art! Good job!',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-27T09:36:13-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'shadowdotm',
          usericon: 'https://a.deviantart.net/avatars/s/h/shadowdotm.jpg?2',
          type: 'regular',
          userId: 23408675,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623705548,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Really Beautiful Art!',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-27T09:22:36-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'I love Tacos',
        user: {
          username: 'OptiMario94',
          usericon: 'https://a.deviantart.net/avatars/o/p/optimario94.png?7',
          type: 'regular',
          userId: 22988921,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623700316,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'This is a very wonderful artwork. When i look a this i image the knight as myself and the Princess Celestia from My Little Pony Friendship Is Magic',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-26T18:25:05-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Krounus',
          usericon: 'https://a.deviantart.net/avatars/k/r/krounus.png?2',
          type: 'regular',
          userId: 16820661,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623480872,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'A gentleman at work. Very good.',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-26T11:38:23-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'Do signatures even work anymore...<br /><br />Oh',
        user: {
          username: 'spacechurro',
          usericon: 'https://a.deviantart.net/avatars/s/p/spacechurro.png?9',
          type: 'regular',
          userId: 32065836,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623325687,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Daily reminder to RESPACT WAMEN',
            features: '',
          },
        },
        authorInfo: 'Student General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-26T08:15:10-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Dorelainendenwen',
          usericon: 'https://a.deviantart.net/avatars/d/o/dorelainendenwen.jpg?1',
          type: 'regular',
          userId: 24742684,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623252887,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'I bought one of these prints, it really moved me. Gorgeous',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-25T21:15:44-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'EmoKitten333',
          usericon: 'https://a.deviantart.net/avatars/e/m/emokitten333.png?13',
          type: 'regular',
          userId: 44890035,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623113308,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'I’m sorry, dude. All I can think is “m’lady” and it’s making this so much better but not ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-25T17:43:18-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Justabipotato',
          usericon: 'https://a.deviantart.net/avatars/j/u/justabipotato.gif?2',
          type: 'regular',
          userId: 46273352,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4623039866,
        typeId: 1,
        itemId: 578845362,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Beautiful 😍', features: '' },
        },
        authorInfo: 'Student Traditional Artist',
        legacyTextEditUrl: null,
      },
    ],
    hasMore: true,
    hasLess: false,
    nextOffset: 24,
    canPostComment: true,
    commentableItemid: 123,
    commentableTypeid: 1,
    cursor: '4623039866',
    prevCursor: null,
  },
  {
    total: 4374,
    thread: [
      {
        posted: '2018-08-04T23:56:17-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'MarkParker1',
          usericon: 'https://a.deviantart.net/avatars/m/a/markparker1.jpg?1',
          type: 'regular',
          userId: 41387083,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4627456984,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Awesome', features: '' },
        },
        authorInfo: 'Student Interface Designer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-14T11:50:35-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          '<a href="http://pythonit.deviantart.com/gallery">[link]</a> check my galery please <img src="https://s.deviantart.com/emoticons/s/smile.gif" width="15" height="15" alt=":)" title=":) (Smile)"/> Landscapes, Lightpainting, macro, wallpapers, etc..<br />Need badges <img src="https://s.deviantart.com/emoticons/b/biggrin.gif" width="15" height="15" alt=":D" title=":D (Big Grin)"/>',
        user: {
          username: 'PythonIt',
          usericon: 'https://a.deviantart.net/avatars/p/y/pythonit.jpg?4',
          type: 'regular',
          userId: 10493569,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4618058546,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Really great ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Photographer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-27T23:22:58-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'pencilprisoner',
          usericon: 'https://a.deviantart.net/avatars/p/e/pencilprisoner.jpg?3',
          type: 'regular',
          userId: 30311862,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4597609897,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'what makes it stand out from the rest?',
            features: '',
          },
        },
        authorInfo: 'Professional Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-20T18:29:16-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'TheGirlfromChelsea',
          usericon: 'https://a.deviantart.net/avatars/t/h/thegirlfromchelsea.png?1',
          type: 'regular',
          userId: 45432561,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4594604090,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'It almost looks like a shadow...',
            features: '',
          },
        },
        authorInfo: 'Student Writer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-20T16:13:55-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: '8aykw',
          usericon: 'https://a.deviantart.net/avatars/8/a/8aykw.gif?1',
          type: 'banned',
          userId: 45746842,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4594553284,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '██████████████░ Loading… 99% ➵ <a class="external" href="https://www.deviantart.com/users/outgoing?http://naked-girls.online/c/track/l/deviantart/HOT-GIRLS">naked-girls.online/c/track/l/d…</a>',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-06T19:20:24-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          "The enjoyment in puncturing the balloons of social hypocrisy is matched only by the idea of 'just desserts', (Pun always intended!) particularly as a form of revenge.",
        user: {
          username: 'Forcedlactationlover',
          usericon: 'https://a.deviantart.net/avatars/f/o/forcedlactationlover.jpg?1',
          type: 'premium',
          userId: 17333931,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4588839724,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Not only beautifully composed, but timed perfectly! ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Writer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-04-19T23:38:30-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'MarisolHackett',
          usericon: 'https://a.deviantart.net/avatars/m/a/marisolhackett.jpg?1',
          type: 'regular',
          userId: 41106588,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4581623697,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Nice one', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-03-31T06:07:44-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'FreeNudeTeenCams',
          usericon: 'https://a.deviantart.net/avatars/f/r/freenudeteencams.gif?3',
          type: 'banned',
          userId: 45353816,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4572609609,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<span>Jerk off with Random TEENS! > <a href="https://freenudeteencams.deviantart.com/"><a href="https://freenudeteencams.deviantart.com/">freenudeteencams.deviantart.co…</a></a></span>',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-03-26T05:39:55-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'GFSex',
          usericon: 'https://a.deviantart.net/avatars/g/f/gfsex.gif?3',
          type: 'banned',
          userId: 45313043,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4570383675,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<span>SEE NUDES OF GIRLS IN YOUR AREA! <a href="https://gfsex.deviantart.com/"><a href="https://gfsex.deviantart.com/">gfsex.deviantart.com/</a></a></span>',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-03-26T01:07:15-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'punishtube-com',
          usericon: 'https://a.deviantart.net/avatars/p/u/punishtube-com.gif?3',
          type: 'banned',
          userId: 45311991,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4570336749,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<span>THE MOST EXTREME TEEN PORN! <a href="https://www.deviantart.com/users/outgoing?http://www.topqualitylink.com/servlet/click/zone?zid=10385&cid=25236&mid=62896&pid=0&sid=32&uuid=f82a0af2594acbbcd34f3629cb822c6c&ip=169.56.95.225&default=false&random=21904904&timestamp=20180325111336&test=false&resolution=768x1024&custom1=%7Btransaction_id%7D&custom2=421&custom3=Yourtracker&custom4=&custom5=FTR&custom6=RON&custom7=STRAIGHT&custom8=a.topqualitylink.com&custom9=10c1c28e-2fbc-49f2-9266-9883bd736375&referrer=http%3A%2F%2Fbestgore.com%2Fall-the-gore%2F&redirect=http%3A%2F%2Fa.topqualitylink.com%2F10c1c28e-2fbc-49f2-9266-9883bd736375%3FsubID1%3D%7Btransaction_id%7D%26affiliateID%3D421%26source%3DYourtracker%26subID2%3DADV10385_25236_62896%3B%26Location_Alias%3DFTR%26Pub%3DRON%26Target%3DSTRAIGHT%26Bnr%3D000052A"><a class="external" href="https://www.deviantart.com/users/outgoing?http://www.topqualitylink.com/servlet/click/zone?zid=10385&cid=25236&mid=62896&pid=0&sid=32&uuid=f82a0af2594acbbcd34f3629cb822c6c&ip=169.56.95.225&default=false&random=21904904&timestamp=20180325111336&test=false&resolution=768x1024&custom1=%7Btransaction_id%7D&custom2=421&custom3=Yourtracker&custom4=&custom5=FTR&custom6=RON&custom7=STRAIGHT&custom8=a.topqualitylink.com&custom9=10c1c28e-2fbc-49f2-9266-9883bd736375&referrer=http%3A%2F%2Fbestgore.com%2Fall-the-gore%2F&redirect=http%3A%2F%2Fa.topqualitylink.com%2F10c1c28e-2fbc-49f2-9266-9883bd736375%3FsubID1%3D%7Btransaction_id%7D%26affiliateID%3D421%26source%3DYourtracker%26subID2%3DADV10385_25236_62896%3B%26Location_Alias%3DFTR%26Pub%3DRON%26Target%3DSTRAIGHT%26Bnr%3D000052A">www.topqualitylink.com/servlet…</a></a></span>',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-01-27T15:04:53-0800',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'petrosillustrations',
          usericon: 'https://a.deviantart.net/avatars/p/e/petrosillustrations.jpg?1',
          type: 'regular',
          userId: 44823629,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4543032254,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'A timeless shot with perfect balance of light and color! Very nice.',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-09-17T11:31:51-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'I love it and it is amazing',
        user: {
          username: 'DarkRBX',
          usericon: 'https://a.deviantart.net/avatars/d/a/darkrbx.png?1',
          type: 'regular',
          userId: 36165811,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4472167553,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Trees and forests look so beautiful in the snow and ice.',
            features: '',
          },
        },
        authorInfo: 'Student Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-08-05T04:13:41-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'MightyZhonghua',
          usericon: 'https://a.deviantart.net/avatars/m/i/mightyzhonghua.png?3',
          type: 'regular',
          userId: 43107139,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4445369914,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              "<span>WARNING! Carry on reading! Or you will die, even if you only looked at the word warning! Once there was a little girl called Clarissa, she was ten-years-old and she lived in a mental hospital, because she killed her mom and her dad. She got so bad she went to kill all the staff in the hospital so the More-government decided that best idea was to get rid of her so they set up a special room to kill her, as humane as possible but it went wrong the machine they were using went wrong. And she sat there in agony for hours until she died. Now every week on the day of her death she returns to the person that reads this letter, on a Monday night at 12:00 a.m. She creeps into your room and kills you slowly, by cutting you and watching you bleed to death. Now send this to ten other pictures on this one site, and she will haunt someone else who doesn't. This isn't fake. apparently, if you copy and paste this to ten comments in the next ten minutes you will have the best day of your life tomorrow.You will either get kissed or asked out, if you break this chain u will see a little dead girl in you</span>",
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-07-29T23:33:58-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'BladeMaster667',
          usericon: 'https://a.deviantart.net/avatars/b/l/blademaster667.jpg?4',
          type: 'regular',
          userId: 23819373,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4441283811,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<span>This is not a joke! Carry on reading! Or you will die, even if you only looked at the word warning!</span><br /><br /><span>Once there was a little girl called Clarissa, she was ten-years-old and she lived in a mental hospital, because she killed her mom a.....................nd her dad. She got so bad she went to kill all the staff in the hospital so the government decided that... See more... ... See MoreSee More... ... See MoreSee More... ... See MoreSee more... ... See MoreSee More... ... See MoreNäytä lisää... ... See MoreSee more... ... See MoreSee More... ... See MoreSee More... See More... See More... ... See moreSee More... ... See MoreSee More... ... See MoreSee More... ... See MoreSee More... ... See MoreSee More ... See Morethe... See More... See More... See More... See More... See More... See More... See More... See More... See More... See More best idea was to get rid of her so they set up a special room to kill her, as humane as possible but it went wrong the machine they were using went wrong. And she sat there in agony for hours until she finally died. Now every week on the day of her death she returns to the person that reads this letter, on a monday night at 12:00a.m. She creeps into your room and kills you slowly, by cutting you and watching you bleed to death. Copy and paste the comment 10 times on this Website ONLY! She will then let you live do it before 12:00a.m on Monday</span>',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-07-22T05:57:01-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'itzikgur',
          usericon: 'https://a.deviantart.net/avatars/i/t/itzikgur.jpg?13',
          type: 'banned',
          userId: 10056667,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4435973014,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'GREAT JOB ! <span class="shadow-holder" data-embed-type="deviation" data-embed-id="691404150" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 300px;" ><span class="shadow mild" ><a class="thumb hasprint" href="https://itzikgur.deviantart.com/art/Sunset-at-Judaean-Mountains-3-691404150" title="Sunset at Judaean Mountains (3) by itzikgur, Jul 9, 2017 in Photography > Animals, Plants & Nature > Landscapes"data-super-img="https://img12.deviantart.net/40a8/i/2017/190/d/5/sunset_at_judaean_mountains__3__by_itzikgur-dbfn6uu.jpg" data-super-width="1024" data-super-height="683" data-super-transparent="false" data-super-alt="Sunset at Judaean Mountains (3) by itzikgur" data-super-full-img="https://img12.deviantart.net/40a8/i/2017/190/d/5/sunset_at_judaean_mountains__3__by_itzikgur-dbfn6uu.jpg" data-super-full-width="1024" data-super-full-height="683" data-sigil="thumb">\n <i></i><img width="300" height="200" alt="Sunset at Judaean Mountains (3) by itzikgur" src="https://t04.deviantart.net/i69wnPdIW8jJWcQFlEPH_CTU0t8=/300x200/filters:fixed_height(100,100):origin()/pre13/7886/th/pre/i/2017/190/d/5/sunset_at_judaean_mountains__3__by_itzikgur-dbfn6uu.jpg" data-src="https://t04.deviantart.net/i69wnPdIW8jJWcQFlEPH_CTU0t8=/300x200/filters:fixed_height(100,100):origin()/pre13/7886/th/pre/i/2017/190/d/5/sunset_at_judaean_mountains__3__by_itzikgur-dbfn6uu.jpg"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span> ',
            features: '',
          },
        },
        authorInfo: 'Professional General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-07-11T13:09:34-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'Who seeks shall find.',
        user: {
          username: 'Nellara',
          usericon: 'https://a.deviantart.net/avatars/n/e/nellara.gif?1',
          type: 'regular',
          userId: 42763196,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4428694101,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Love this~!', features: '' },
        },
        authorInfo: 'Hobbyist General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-07-05T13:54:56-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          'I want to share your mouthful<br />I want to do all things your lungs do so well<br />I gonna bed into you like a cat prance into a bean bag<br />Turn you inside out and lick you like a crisp packet - Every Other Freckle by alt-j',
        user: {
          username: 'Vixie1979',
          usericon: 'https://a.deviantart.net/avatars/v/i/vixie1979.jpg?11',
          type: 'regular',
          userId: 23866342,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4424573362,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'This is beautiful! ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-07-02T13:30:24-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'MarzKartoons',
          usericon: 'https://a.deviantart.net/avatars/m/a/marzkartoons.png?12',
          type: 'premium',
          userId: 38589118,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4422574301,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'Wow, this is gorgeous! <img src="https://e.deviantart.net/emoticons/e/eek.gif" alt=":o (Eek)" style="width: 15px; height: 15px;" data-embed-type="emoticon" data-embed-id="375"> ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-06-25T13:55:54-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'boywonderiye',
          usericon: 'https://a.deviantart.net/avatars/b/o/boywonderiye.jpg?1',
          type: 'regular',
          userId: 10853687,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4417886966,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'i love this, can i use it for one of my graphic designs',
            features: '',
          },
        },
        authorInfo: 'Professional Artisan Crafter',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-05-28T05:49:56-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'Giftcardforfree',
          usericon: 'https://a.deviantart.net/avatars/g/i/giftcardforfree.gif?1',
          type: 'banned',
          userId: 42623033,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4398872291,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'G I F T  C A R.D S  F R E.E  <br />R I G H T  H E R E --> <a class="external" href="https://www.deviantart.com/users/outgoing?https://mobile.twitter.com/all4nocost/status/863114178382508032">mobile.twitter.com/all4nocost/…</a><br /><br /><span class="shadow-holder" data-embed-type="deviation" data-embed-id="8293197339132895" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 300px;" ><span class="tt-bb" style="width: 300px;"></span><span class="shadow mild" style="width: 300px;"><a class="thumb" href="https://sta.sh/029noy9fpjvj" title="Untitled by Giftcardforfree, May 28, 2017"data-super-img="https://img11.deviantart.net/8ffa/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-super-width="1024" data-super-height="409" data-super-transparent="false" data-super-alt="Untitled by Giftcardforfree" data-super-full-img="https://orig09.deviantart.net/a2d1/f/2017/148/9/f/untitled_by_giftcardforfree-dbapi3t.png" data-super-full-width="1262" data-super-full-height="504" data-sigil="thumb">\n <i></i><img width="300" height="120" alt="Untitled by Giftcardforfree" src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span>  ',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-05-25T18:29:02-0700',
        edited: null,
        replies: 1,
        likes: 0,
        hidden: null,
        signature:
          'Jesus is my lord and savior! <br /><br />&#9744;&#65279; Taken<br /><br />&#9744; Single<br /><br />&#10004; Mentally married to Arthur Kirkland (still love you though :iconsexyiggyplz: :iconheart: ) and having an affair with Alfred F. Jones :iconsexyamericaplz:',
        user: {
          username: 'mermaidfan',
          usericon: 'https://a.deviantart.net/avatars/m/e/mermaidfan.gif?11',
          type: 'regular',
          userId: 4199360,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4397341640,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<a class="external" href="https://www.deviantart.com/users/outgoing?http://mermaidfan.prinab.a.clickbetter.com/?pid=24481511">mermaidfan.prinab.a.clickbette…</a>',
            features: '',
          },
        },
        authorInfo: 'Student General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-05-28T05:50:00-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'Giftcardforfree',
          usericon: 'https://a.deviantart.net/avatars/g/i/giftcardforfree.gif?1',
          type: 'banned',
          userId: 42623033,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4398872316,
        typeId: 1,
        itemId: 1359942,
        parentId: 4397341640,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,

        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'G I F T  C A R.D S  F R E.E  <br />R I G H T  H E R E --> <a class="external" href="https://www.deviantart.com/users/outgoing?https://mobile.twitter.com/all4nocost/status/863114178382508032">mobile.twitter.com/all4nocost/…</a><br /><br /><span class="shadow-holder" data-embed-type="deviation" data-embed-id="8293197339132895" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 300px;" ><span class="tt-bb" style="width: 300px;"></span><span class="shadow mild" style="width: 300px;"><a class="thumb" href="https://sta.sh/029noy9fpjvj" title="Untitled by Giftcardforfree, May 28, 2017"data-super-img="https://img11.deviantart.net/8ffa/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-super-width="1024" data-super-height="409" data-super-transparent="false" data-super-alt="Untitled by Giftcardforfree" data-super-full-img="https://orig09.deviantart.net/a2d1/f/2017/148/9/f/untitled_by_giftcardforfree-dbapi3t.png" data-super-full-width="1262" data-super-full-height="504" data-sigil="thumb">\n <i></i><img width="300" height="120" alt="Untitled by Giftcardforfree" src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span>  ',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-05-23T13:38:28-0700',
        edited: null,
        replies: 1,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Lucy3DS',
          usericon: 'https://a.deviantart.net/avatars/l/u/lucy3ds.jpg?7',
          type: 'regular',
          userId: 36841460,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4395925072,
        typeId: 1,
        itemId: 1359942,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'beautiful picture ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Photographer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2017-05-28T05:50:02-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'Giftcardforfree',
          usericon: 'https://a.deviantart.net/avatars/g/i/giftcardforfree.gif?1',
          type: 'banned',
          userId: 42623033,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4398872330,
        typeId: 1,
        itemId: 1359942,
        parentId: 4395925072,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'G I F T  C A R.D S  F R E.E  <br />R I G H T  H E R E --> <a class="external" href="https://www.deviantart.com/users/outgoing?https://mobile.twitter.com/all4nocost/status/863114178382508032">mobile.twitter.com/all4nocost/…</a><br /><br /><span class="shadow-holder" data-embed-type="deviation" data-embed-id="8293197339132895" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 300px;" ><span class="tt-bb" style="width: 300px;"></span><span class="shadow mild" style="width: 300px;"><a class="thumb" href="https://sta.sh/029noy9fpjvj" title="Untitled by Giftcardforfree, May 28, 2017"data-super-img="https://img11.deviantart.net/8ffa/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-super-width="1024" data-super-height="409" data-super-transparent="false" data-super-alt="Untitled by Giftcardforfree" data-super-full-img="https://orig09.deviantart.net/a2d1/f/2017/148/9/f/untitled_by_giftcardforfree-dbapi3t.png" data-super-full-width="1262" data-super-full-height="504" data-sigil="thumb">\n <i></i><img width="300" height="120" alt="Untitled by Giftcardforfree" src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png" data-src="https://t07.deviantart.net/aSDFGCEmubQc89b-TBaB5jhjg88=/300x200/filters:fixed_height(100,100):origin()/pre01/3841/th/pre/i/2017/148/1/e/untitled_by_giftcardforfree-dbapi3t.png"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span>  ',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
    ],
    hasMore: true,
    hasLess: false,
    nextOffset: 24,
    cursor: '4398872330',
    prevCursor: null,
    canPostComment: true,
    commentableItemid: 123,
    commentableTypeid: 1,
  },
  {
    total: 9849,
    thread: [
      {
        posted: '2018-08-08T05:14:55-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          '<a href="http://frappe7.deviantart.com/gallery/">My Gallery</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?https://picarto.tv/Frappe7/">Picarto Channel</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?http://frappeart.tumblr.com/">Tumblr</a> | <a class="external" href="http://www.deviantart.com/users/outgoing?https://toyhou.se/frappe7">Toyhouse</a>',
        user: {
          username: 'Frappe7',
          usericon: 'https://a.deviantart.net/avatars/f/r/frappe7.gif?13',
          type: 'beta',
          userId: 29929163,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4628833263,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'daaang, persephone is gorgeous!',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-06T11:24:15-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          'If I show up at your door, chances are you did something to bring me there. <br />Grosse Pointe Blank (1997)<br /><br />www.amaz0ns.com<br /><br />www.infowars.com',
        user: {
          username: 'MiloMorai',
          usericon: 'https://a.deviantart.net/avatars/m/i/milomorai.jpg?5',
          type: 'regular',
          userId: 3864041,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4628067712,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'At first glance, I thought of Sauron and Luthien (The Silmarillion) rather then Hades and Persephone.',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-06T04:06:04-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'HadesArts',
          usericon: 'https://a.deviantart.net/avatars/h/a/hadesarts.gif?5',
          type: 'regular',
          userId: 44369757,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4627933942,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: "It's beautiful ",
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-08-04T23:55:51-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'MarkParker1',
          usericon: 'https://a.deviantart.net/avatars/m/a/markparker1.jpg?1',
          type: 'regular',
          userId: 41387083,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4627456900,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Nice one', features: '' },
        },
        authorInfo: 'Student Interface Designer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-23T08:30:43-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'UNDER CONSTRUCTION',
        user: {
          username: 'CableCake',
          usericon: 'https://a.deviantart.net/avatars/c/a/cablecake.jpg?2',
          type: 'regular',
          userId: 22942079,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4621930571,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'This is incredible!',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-18T09:04:22-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'AlfaBreloom101',
          usericon: 'https://a.deviantart.net/avatars/a/l/alfabreloom101.jpg?1',
          type: 'regular',
          userId: 46163232,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4619754030,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: '<div>Wow...Just...Wow</div><div>10/10<br /></div>',
            features: '',
          },
        },
        authorInfo: 'Student Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-09T02:49:58-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Zorbruh',
          usericon: 'https://a.deviantart.net/avatars/z/o/zorbruh.jpg?13',
          type: 'regular',
          userId: 42426051,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4615725948,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              "The details are amazing : )<br />good job friend<br />keep doing what you're doing",
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-03T07:26:54-0700',
        edited: null,
        replies: 1,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'TrashForDeviants',
          usericon: 'https://a.deviantart.net/avatars/t/r/trashfordeviants.jpg?4',
          type: 'regular',
          userId: 43314224,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4613230309,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'vary noice', features: '' },
        },
        authorInfo: 'Hobbyist Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-04T16:58:09-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'mazepla',
          usericon: 'https://a.deviantart.net/avatars/m/a/mazepla.gif?8',
          type: 'regular',
          userId: 46094993,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4613871455,
        typeId: 1,
        itemId: 210920648,
        parentId: 4613230309,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              "Good expression good anatomy good perspective  good mood  oh everything's good.",
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-07-01T11:09:10-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Warrior-of-Faith',
          usericon: 'https://a.deviantart.net/avatars/w/a/warrior-of-faith.png',
          type: 'regular',
          userId: 31335794,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4612439726,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Its beautiful.  ',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Writer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-28T11:21:46-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Djeidi-123',
          usericon: 'https://a.deviantart.net/avatars/d/j/djeidi-123.png?6',
          type: 'regular',
          userId: 25007246,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4611161668,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              "I do believe this artwork will soon break dA's favourite counter. Anyway you deserve it, it's great >w<",
            features: '',
          },
        },
        authorInfo: 'Hobbyist General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-24T20:02:15-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'Dubaiescortx',
          usericon: 'https://a.deviantart.net/avatars/d/u/dubaiescortx.gif?2',
          type: 'banned',
          userId: 46024599,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4609647188,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '🍒available today<br />dating 🍒/ massage🍒 / from pak DUBAI 🍒 whatsapp<br />+971554249356<br /><span class="shadow-holder" data-embed-type="deviation" data-embed-id="8872027575877962" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 133px;" ><span class="tt-bb" style="width: 133px;"></span><span class="shadow mild" style="width: 133px;"><a class="thumb" href="https://sta.sh/02fcvd79ppai" title="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx, Jun 24, 2018"data-super-img="https://pre00.deviantart.net/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-super-width="730" data-super-height="1095" data-super-transparent="false" data-super-alt="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx" data-super-full-img="https://orig00.deviantart.net/ca63/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-super-full-width="853" data-super-full-height="1280" data-sigil="thumb">\n <i></i><img width="133" height="200" alt="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx" src="https://t00.deviantart.net/6nh2Qe8LjJHpYWC4AmksObb-q1g=/300x200/filters:fixed_height(100,100):origin()/pre00/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-src="https://t00.deviantart.net/6nh2Qe8LjJHpYWC4AmksObb-q1g=/300x200/filters:fixed_height(100,100):origin()/pre00/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span>  <span class="shadow-holder" data-embed-type="deviation" data-embed-id="8872027575877962" data-embed-format="thumb"><span class="tt-fh-tc" style="width: 133px;" ><span class="tt-bb" style="width: 133px;"></span><span class="shadow mild" style="width: 133px;"><a class="thumb" href="https://sta.sh/02fcvd79ppai" title="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx, Jun 24, 2018"data-super-img="https://pre00.deviantart.net/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-super-width="730" data-super-height="1095" data-super-transparent="false" data-super-alt="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx" data-super-full-img="https://orig00.deviantart.net/ca63/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-super-full-width="853" data-super-full-height="1280" data-sigil="thumb">\n <i></i><img width="133" height="200" alt="335fb8b1-04bd-4835-a026-52d88d5a1be3 by Dubaiescortx" src="https://t00.deviantart.net/6nh2Qe8LjJHpYWC4AmksObb-q1g=/300x200/filters:fixed_height(100,100):origin()/pre00/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg" data-src="https://t00.deviantart.net/6nh2Qe8LjJHpYWC4AmksObb-q1g=/300x200/filters:fixed_height(100,100):origin()/pre00/5dfc/th/pre/f/2018/175/3/2/335fb8b1_04bd_4835_a026_52d88d5a1be3_by_dubaiescortx-dcfcqdx.jpg"></a></span><!-- ^TTT --></span><span class="details" ></span><!-- TTT$ --></span>  ',
            features: '',
          },
        },
        authorInfo: 'Professional Photographer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-18T12:38:33-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'pastelxpetal',
          usericon: 'https://a.deviantart.net/avatars/p/a/pastelxpetal.png?1',
          type: 'regular',
          userId: 45307664,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4606902994,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'i love it!!', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-14T10:02:18-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'dreamybluewhale',
          usericon: 'https://a.deviantart.net/avatars/default.gif',
          type: 'regular',
          userId: 45900432,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4605141459,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Beautiful!', features: '' },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-14T00:56:05-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          'Melinda Zupan<br /> Committed to creating art that is worthy of support. Always trying to improve my ability. Better and better is my vision.',
        user: {
          username: 'mzupan',
          usericon: 'https://a.deviantart.net/avatars/m/z/mzupan.jpg?4',
          type: 'premium',
          userId: 41016895,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4605015191,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              'absolutely amazing<img src="https://e.deviantart.net/emoticons/b/biggrin.gif" width="15" height="15" alt=":D" data-embed-type="emoticon" data-embed-id="366" title=":D (Big Grin)"/>',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-09T18:14:43-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: 'Ante mi, usted solo tiene dos opciones: me odia o me ama.',
        user: {
          username: 'AlexFireflyZhou',
          usericon: 'https://a.deviantart.net/avatars/a/l/alexfireflyzhou.jpg?2',
          type: 'regular',
          userId: 45536400,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4603164778,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Really beautiful anmd romantic u.u',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-05T19:39:03-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'pencilprisoner',
          usericon: 'https://a.deviantart.net/avatars/p/e/pencilprisoner.jpg?3',
          type: 'regular',
          userId: 30311862,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4601523878,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'great piece', features: '' },
        },
        authorInfo: 'Professional Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-05T11:46:45-0700',
        edited: '2018-06-05T12:54:28-0700',
        replies: 0,
        likes: 0,
        hidden: 'hidden_as_spam',
        signature: null,
        user: {
          username: 'Official-DeviantArt',
          usericon: 'https://a.deviantart.net/avatars/o/f/official-deviantart.gif?2',
          type: 'banned',
          userId: 45864344,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4601339076,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: true,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup:
              '<p><span><b><i>Due to a recent bankruptcy; we may be shutting down our website. If you donate Bitcoin here to show that you still care - then we may change our mind:</i></b><br /><br />1Eimd88ZAPYxgbkiKakruk4rLRt7rCAqcC</span></p>',
            features: '',
          },
        },
        authorInfo: null,
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-06-01T05:16:29-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Bulletkingishere',
          usericon: 'https://a.deviantart.net/avatars/b/u/bulletkingishere.jpg?1',
          type: 'regular',
          userId: 45551191,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4599440911,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: { type: 'writer', markup: 'Lord Hades', features: '' },
        },
        authorInfo: 'Student General Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-30T13:45:57-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'Jalyns-art',
          usericon: 'https://a.deviantart.net/avatars/j/a/jalyns-art.jpg?2',
          type: 'regular',
          userId: 45818774,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4598744200,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'This is amazing!',
            features: '',
          },
        },
        authorInfo: 'Hobbyist Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-27T23:23:31-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'pencilprisoner',
          usericon: 'https://a.deviantart.net/avatars/p/e/pencilprisoner.jpg?3',
          type: 'regular',
          userId: 30311862,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4597610011,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Great concept',
            features: '',
          },
        },
        authorInfo: 'Professional Traditional Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-27T15:44:34-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'artchamaleon',
          usericon: 'https://a.deviantart.net/avatars/a/r/artchamaleon.png?4',
          type: 'regular',
          userId: 41956351,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4597457836,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'Wooww absolutely stunning',
            features: '',
          },
        },
        authorInfo: 'Professional Digital Artist',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-20T18:31:25-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature: null,
        user: {
          username: 'TheGirlfromChelsea',
          usericon: 'https://a.deviantart.net/avatars/t/h/thegirlfromchelsea.png?1',
          type: 'regular',
          userId: 45432561,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4594604873,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'I love how you drew Hades in this!',
            features: '',
          },
        },
        authorInfo: 'Student Writer',
        legacyTextEditUrl: null,
      },
      {
        posted: '2018-05-03T10:42:43-0700',
        edited: null,
        replies: 0,
        likes: 0,
        hidden: null,
        signature:
          '“No matter what anybody tells you, words and ideas can change the world.” - Robin Williams, Dead Poets Society.',
        user: {
          username: 'AlanVannes',
          usericon: 'https://a.deviantart.net/avatars/a/l/alanvannes.jpg?2',
          type: 'regular',
          userId: 39609918,
          useridUuid: '',
          isNewDeviant: true,
        },
        commentId: 4587349683,
        typeId: 1,
        itemId: 210920648,
        parentId: null,
        isOwner: false,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: false,
        isAdminMode: false,
        isFeatured: false,
        isLiked: false,
        isReportable: false,
        textContent: {
          excerpt: '',
          html: {
            type: 'writer',
            markup: 'I absolutely love this pic, especially Hades’ armor.',
            features: '',
          },
        },
        authorInfo: 'Professional Writer',
        legacyTextEditUrl: null,
      },
    ],
    hasMore: true,
    hasLess: false,
    nextOffset: 24,
    cursor: '4587349683',
    prevCursor: null,
    canPostComment: true,
    commentableItemid: 123,
    commentableTypeid: 1,
  },
];
const draft: PapiCommentThread[] = [
  {
    total: 1987,
    hasMore: true,
    hasLess: false,
    nextOffset: 24,
    cursor: '4587349683',
    prevCursor: null,
    canPostComment: true,
    commentableItemid: 123,
    commentableTypeid: 1,
    thread: [
      {
        commentId: 4733669351,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-05-16T02:08:58-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: '\n \n',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"ahn3l","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"89hfe","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"5m173","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-video","mutability":"IMMUTABLE","data":{"config":{"size":"content","alignment":"center"},"title":"Set Link for Video","description":"Add a link to your video","placeholder":"https://www.youtube.com/watch?v=gi7dTKse9Tg","errorMessage":"Please enter a correct address","src":"https://www.youtube.com/watch?v=Vfnj4RotX5Y"}}}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":1}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":0}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4733669301,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-05-16T02:08:35-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'Test\n \n',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"Test","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5kr7c","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"28of2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-video","mutability":"IMMUTABLE","data":{"config":{"size":"content","alignment":"center"},"title":"Set Link for Video","description":"Add a link to your video","placeholder":"https://www.youtube.com/watch?v=gi7dTKse9Tg","errorMessage":"Please enter a correct address","src":"https://www.youtube.com/watch?v=Vfnj4RotX5Y"}}}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":1}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4733654605,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-05-15T23:49:38-0700',
        edited: '2019-05-16T01:38:03-0700',
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'asdasd :D  \n \nsaasdasd',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"80t42","text":"asdasd :D  ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":7,"length":3,"key":0}],"data":{}},{"key":"e0f4t","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":1}],"data":{}},{"key":"72avf","text":"saasdasd","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":8,"key":2}],"data":{}}],"entityMap":{"0":{"type":"DA_OFF_EMOTE","mutability":"IMMUTABLE","data":{"emote":":D "}},"1":{"type":"wix-draft-plugin-giphy","mutability":"IMMUTABLE","data":{"config":{"size":"small","alignment":"center"},"gif":{"originalUrl":"https://media3.giphy.com/media/W4zy5MSyQ1MAPaXzlS/giphy.gif","stillUrl":"https://media3.giphy.com/media/W4zy5MSyQ1MAPaXzlS/giphy_s.gif","height":254,"width":480}}},"2":{"type":"LINK","mutability":"MUTABLE","data":{"url":"www.example.org","target":"_blank","rel":"nofollow"}}}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":1,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":17}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4733654589,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-05-15T23:49:32-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'asdasd :D  asdasdasd',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"asdasd :D  asdasdasd","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":7,"length":3,"key":0}],"data":{}}],"entityMap":{"0":{"type":"DA_OFF_EMOTE","mutability":"IMMUTABLE","data":{"emote":":D "}}}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":17}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4695573608,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-01-30T02:20:31-0800',
        edited: '2019-01-30T02:22:57-0800',
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'test111',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"test111","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":7}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4688362983,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2019-01-11T08:52:42-0800',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'test',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"test","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4669278858,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-11-21T06:23:55-0800',
        edited: '2018-11-21T06:24:02-0800',
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'foo bar',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"foo bar","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":7}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4666772106,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-11-14T11:37:25-0800',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: '@dt foop',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"@dt foop","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":3,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"IMMUTABLE","data":{"mention":{"name":"dt","avatar":"https://a.deviantart.net/avatars/d/t/dt.png?3"}}}}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":1,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":8}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4638261110,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-08-31T05:11:59-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'Mogę jeść szkło i mi nie szkodzi.',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"Mogę jeść szkło i mi nie szkodzi.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":8,"chars":37}}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4637846466,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-08-30T02:54:45-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'test',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"test","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"FIRST_IMAGE_FEATURE","data":[]}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4633992137,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-08-20T12:10:25-0700',
        edited: null,
        replies: 1,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'Test 2',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"Test 2","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":6}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"FIRST_IMAGE_FEATURE","data":[]}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4633992244,
        typeId: 4,
        itemId: 19960677,
        parentId: 4633992137,
        posted: '2018-08-20T12:10:41-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'Foop',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"Foop","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"FIRST_IMAGE_FEATURE","data":[]}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4633975268,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-08-20T11:24:35-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'test :D  :p ',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"5tmpc","text":"test :D  :p ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":5,"length":2,"key":0},{"offset":9,"length":2,"key":1}],"data":{}}],"entityMap":{"0":{"type":"DA_OFF_EMOTE","mutability":"IMMUTABLE","data":{"emote":":D"}},"1":{"type":"DA_OFF_EMOTE","mutability":"IMMUTABLE","data":{"emote":":p"}}}}',
            features:
              '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":12}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":2,"images":0,"mentions":0,"video":0}},{"type":"FIRST_IMAGE_FEATURE","data":[]}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
      {
        commentId: 4633975144,
        typeId: 4,
        itemId: 19960677,
        parentId: null,
        posted: '2018-08-20T11:24:13-0700',
        edited: null,
        replies: 0,
        isOwner: true,
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isSpam: false,
        isAuthorHighlited: false,
        isPrivate: false,
        isAnnotation: false,
        isDeleted: false,
        isAuthor: true,
        isAdminMode: true,
        isFeatured: false,
        isReportable: false,
        isLiked: false,
        likes: 0,
        hidden: null,
        textContent: {
          excerpt: 'Test',
          html: {
            type: 'draft',
            markup:
              '{"blocks":[{"key":"foo","text":"Test","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            features:
              '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"FIRST_IMAGE_FEATURE","data":[]}]',
          },
        },
        signature: null,
        authorInfo: 'Hobbyist General Artist',
        user: {
          userId: 19960677,
          useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
          username: 'muteor',
          usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
          type: 'admin',
          isNewDeviant: false,
        },
        isTextEditable: true,
        legacyTextEditUrl: null,
      },
    ],
  },
];

function threadReducer(threads: PapiCommentThread[]): PapiComment[] {
  return threads.reduce(
    (previousValue, currentValue) => [...previousValue, ...currentValue.thread],
    [] as PapiComment[]
  );
}

export const commentThreads = [...legacy, ...draft];
export const commentThreadsByType = {
  legacy,
  draft,
};

export const commentsByType = {
  legacy: threadReducer(legacy),
  draft: threadReducer(draft),
};

export const comments: PapiComment[] = [...commentsByType.legacy, ...commentsByType.draft];
